import React from 'react';
import {get as _get, isEmpty as _isEmpty} from 'lodash';

import {NO_WATERMARKING_CIDR, NO_WATERMARKING_CLIENTS} from '@constants/messages';

export const hasNoWatermarkingCidrs = (row) => _isEmpty(String(_get(row, 'cidrs', '') || '').trim());

export const hasNoWatermarkingClients = (row) => _isEmpty(_get(row, 'clients', []));

export const showWatermarkingRowWarning = (row) => (
    hasNoWatermarkingCidrs(row) || hasNoWatermarkingClients(row)
);

export const getWatermarkingRowClassname = (row) => (
    showWatermarkingRowWarning(row) ? '--row-orange-background-color' : ''
);

export const getWatermarkingRowWarningText = (row) => {
    const textTooltip = [];

    if (hasNoWatermarkingCidrs(row)) {
        textTooltip.push(
            <>
                {NO_WATERMARKING_CIDR}
                <br />
            </>
        );
    }

    if (hasNoWatermarkingClients(row)) {
        textTooltip.push(
            <>
                {NO_WATERMARKING_CLIENTS}
                <br />
            </>
        );
    }

    return textTooltip;
};
